/**
 * Utility to resolve image URLs between remote VPS server and local assets
 */

export const getBackendBaseUrl = (): string => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL.replace(/\/api\/?$/, '');
  }
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL.replace(/\/api\/?$/, '');
  }
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    const protocol = window.location.protocol;
    if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.startsWith('192.168.') || hostname.startsWith('10.')) {
      return `${protocol}//${hostname}:5000`;
    }
    if (hostname.includes('aswcars.com')) {
      return 'https://backend.aswcars.com';
    }
  }
  return 'https://backend.aswcars.com';
};

/**
 * Resolves an image path to either a server URL or local static asset
 */
export const resolveImageUrl = (src: string): string => {
  if (!src) return '';
  
  // If already absolute URL (http/https/data URI)
  if (src.startsWith('http://') || src.startsWith('https://') || src.startsWith('data:')) {
    return src;
  }

  // If path is stored as server upload (/uploads/...)
  if (src.startsWith('/uploads/')) {
    const base = getBackendBaseUrl();
    return `${base}${src}`;
  }

  return src;
};

/**
 * Gets a local fallback asset path if server image fails to load
 */
export const getLocalFallbackUrl = (src: string): string | null => {
  if (!src) return null;

  // If failed image was from /uploads/cars/xyz.jpg -> try /Website-Images/Cars/xyz.jpg
  if (src.includes('/uploads/cars/')) {
    const filename = src.split('/uploads/cars/').pop();
    return filename ? `/Website-Images/Cars/${filename}` : null;
  }

  // If failed image was from /uploads/banners/xyz.jpg -> try /Website-Images/Banners/xyz.jpg
  if (src.includes('/uploads/banners/')) {
    const filename = src.split('/uploads/banners/').pop();
    return filename ? `/Website-Images/Banners/${filename}` : null;
  }

  // If failed image was from /uploads/brands/xyz.jpg -> try /Website-Images/Brands/xyz.jpg
  if (src.includes('/uploads/brands/')) {
    const filename = src.split('/uploads/brands/').pop();
    return filename ? `/Website-Images/Brands/${filename}` : null;
  }

  // If failed image was from /uploads/banks/xyz.jpg -> try /Website-Images/Banks/xyz.jpg
  if (src.includes('/uploads/banks/')) {
    const filename = src.split('/uploads/banks/').pop();
    return filename ? `/Website-Images/Banks/${filename}` : null;
  }

  return null;
};
